import { useEffect, useRef, useState } from 'react';

/**
 * Tracks scroll progress (0 -> 1) while a tall section is pinned by an inner
 * `position: sticky` child. Used by the "Everything You Need" pinned section
 * so the left list + right preview advance as the user scrolls, then release.
 */
export function useScrollProgress() {
  const ref = useRef(null);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    let raf = 0;
    const update = () => {
      const rect = el.getBoundingClientRect();
      const distance = el.offsetHeight - window.innerHeight;
      const scrolled = Math.min(Math.max(-rect.top, 0), distance);
      setProgress(distance > 0 ? scrolled / distance : 0);
    };

    const onScroll = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(update);
    };

    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      cancelAnimationFrame(raf);
    };
  }, []);

  return { ref, progress };
}
